export default "__VITE_ASSET__CeUubaPh__"